import { ArrowLeft } from "lucide-react";

export const StepShell = ({ step, total, intro, title, subtitle, onBack, children, footer, testid }) => (
  <div className="adv-card p-4 sm:p-7" data-testid={testid}>
    <div className="flex items-center justify-between mb-5">
      <button onClick={onBack} className="text-[#a9a398] hover:text-[#F3EEE4] flex items-center gap-1 text-sm" data-testid="btn-step-back">
        <ArrowLeft className="h-4 w-4" /> Geri
      </button>
      <div className="flex items-center gap-1.5" data-testid="step-progress">
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} className={`h-1.5 rounded-full transition-all ${i < step ? "w-8 bg-[#D6AD62]" : "w-4 bg-white/10"}`} />
        ))}
      </div>
    </div>
    {intro && <p className="text-[#F3D592] font-medium mb-2" data-testid="step-intro">{intro}</p>}
    <h3 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h3>
    {subtitle && <p className="text-[#a9a398] text-sm mt-1">{subtitle}</p>}
    <div className="mt-6">{children}</div>
    {footer && <div className="mt-6">{footer}</div>}
  </div>
);
